var map = {
	"./coffeeText.png": "ab4c",
	"./effect1.png": "e762",
	"./effect2.png": "0746",
	"./error.png": "1fe8",
	"./errorMessage.png": "cfd5",
	"./ipog.png": "ed5e",
	"./logo.png": "cf05",
	"./lunchText.png": "be3e",
	"./rooms2Text.png": "0f8a",
	"./roomsText.png": "9e12",
	"./welcome.png": "5d18"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";